import {Controller} from 'stimulus'

export default class extends Controller {
    static targets = ['searchType', 'targetStoreCodes', 'targetYearMonth']

    initialize() {
        this.checkSearchType();
    }

    checkSearchType() {
        let toTargetDisable = false;
        this.searchTypeTargets.forEach((el, i) => {
            if(el.checked && ~~el.value === 0) {
                toTargetDisable = true;
            }
        })
        this.targetYearMonthTarget.disabled = !toTargetDisable;
        this.targetStoreCodesTarget.disabled = toTargetDisable;
    }
}
